export class UserIdleConfig {
  /** Idle duration in seconds before timeout */
  idleDuration?: number;
  /** Duration to warn the user after idle duration is ellapsed */
  timeout?: number;
  /** Buffer time in seconds before start to detect idle */
  idleBuffer?: number;
}
